import { render } from "./CheckoutSideItens01.vue?vue&type=template&id=0e3148a1&scoped=true"
import script from "./CheckoutSideItens01.vue?vue&type=script&lang=js"
export * from "./CheckoutSideItens01.vue?vue&type=script&lang=js"

import "./CheckoutSideItens01.vue?vue&type=style&index=0&id=0e3148a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3148a1"]])

export default __exports__